import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { BsArrowUp, BsArrowDown, BsArrowDownUp } from "react-icons/bs";
import { AiOutlineEye, AiOutlineSearch } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Button,
  Col,
  Input,
  Label,
  Row,
  Form,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as actions from "../../../../../store/modules/conferenciaCr/actions";
import * as controller from "../../../../../controllers/conferenciaCrController";
import ModalLoja from "../../../components/ModaLoja";
import ModalDetalhamento from "../../../components/ModalDetalhamento";
import { GrFormClose } from "react-icons/gr";
import { maskMoedaRawPreservaSinal } from "../../../../../util/masks";
import { COLUMNS } from "../../../constants/columns";
import { Select } from "../../../../../components/Inputs/Input";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";
import "./style.css";

const SearchConferenciaCr = ({ ativo }) => {
  const {
    search,
    comissoesRecebidaAgrupado,
    getAllAgrupado,
    instituicoes,
    centrosCusto,
    arquivo,
    arquivoCp,
    tiposComissao,
    contasBancaria,
    statusComissaoRecebida,
    integrado,
    contaCorrente,
    tiposTitulo
  } = useSelector((state) => state.conferenciaCr);
  const columns = useMemo(() => COLUMNS, []);
  const data = comissoesRecebidaAgrupado;
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    state,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageSize } = state;
  const [initialPage, setInitialPage] = useState(false);
  const [selectedPage, setSelectedPage] = useState(null);
  const [selecionados, setSelecionados] = useState({});
  const [isModalBaixaOpen, setIsModalBaixaOpen] = useState(false);
  const [isModalDetalhamentoOpen, setIsModalDetalhamentoOpen] = useState(false);
  const [isModalLojaOpen, setIsModalLojaOpen] = useState(false);
  const [comissaoId, setComissaoId] = useState("0");
  const toggleLoja = () => setIsModalLojaOpen(!isModalLojaOpen);
  const toggleDetalhamento = () =>
    setIsModalDetalhamentoOpen(!isModalDetalhamentoOpen);

  const handlePageClick = (e) => {
    const pageSelected = e.selected;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);
    controller.getComissaoAgrupada(search, pageSize, pageSelected + 1);
  };

  useEffect(() => {
    if (getAllAgrupado.tamanhoPagina) {
      setPageSize(getAllAgrupado.tamanhoPagina);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAllAgrupado]);

  useEffect(() => {
    controller.getTiposcomissao();
    controller.getInstituicoes();
    controller.getCentrosCusto();
    controller.getStatusAgrupamentoComissaoRecebida();
    controller.getAllContasCorrente();
  }, []);

  useEffect(() => {
    actions.setSearch("contaBancaria", "0");
    if (search.lojaId === "0") {
      actions.setContasBancaria([]);
    } else {
      controller.getContasBancaria(search.lojaId);
    }
  }, [search.lojaId]);

  function handleInitialPage(pageSize) {
    const pageSelected = 0;
    setInitialPage(false);
    setSelectedPage(pageSelected);
    gotoPage(pageSelected);
    controller.getComissaoAgrupada(search, pageSize, pageSelected + 1);
  }

  function onChange(value, field) {
    actions.setSearch(field, value);
  }

  function getAll() {
    setSelecionados({});
    controller.getComissaoAgrupada(search, pageSize, 1);
    gotoPage(0);
    setInitialPage(true);
    setSelectedPage(0);
  }

  function seeRegister(id) {
    setComissaoId(id);
    controller.getComissao(search, 10, 1, id);
    toggleDetalhamento();
  }

  function handleSelectComissao(item) {
    const novos = { ...selecionados };
    if (novos[item.id]) {
      delete novos[item.id];
    } else {
      novos[item.id] = item;
    }
    setSelecionados(novos);
  }

  const todosDaPaginaSelecionados =
    data.length > 0 && data.every((e) => selecionados[e.id]);

  function handleSelectAllComissoes() {
    const novos = { ...selecionados };
    data.forEach((e) => {
      if (todosDaPaginaSelecionados) {
        delete novos[e.id];
      } else {
        novos[e.id] = e;
      }
    });
    setSelecionados(novos);
  }

  async function handleBaixarComissoes() {
    await controller.baixarPlanilha(search, pageSize, 1);
    document.getElementById("download").click();
  }

  const listaSelecionados = Object.values(selecionados);
  const quantidadeSelecionados = listaSelecionados.length;

  async function confirmarBaixa() {
    const baixou = await controller.baixaComissao(
      listaSelecionados.map((item) => ({ id: item.id }))
    );
    setIsModalBaixaOpen(false);
    if (baixou) {
      getAll();
    }
  }

  async function handleBaixarCP() {
    await controller.baixarCP(
      listaSelecionados.map((item) => ({ id: item.id }))
    );
    document.getElementById("downloadCP").click();
  }

  useEffect(() => {
    if (!ativo) {
      setSelecionados({});
    }
  }, [ativo]);

  function somar(values) {
    return values.reduce((a, b) => a + (Number(b) || 0), 0);
  }

  function getTotalValue(total) {
    return maskMoedaRawPreservaSinal(total.toFixed(2));
  }
  const contasCorrente = search.lojaId === "0" ? contaCorrente : contasBancaria;

  const totaisDoServidor = getAllAgrupado.totalValorBruto !== undefined;
  const rotuloTotais = totaisDoServidor ? "" : " (página)";
  const totalValorBruto = getTotalValue(
    totaisDoServidor
      ? Number(getAllAgrupado.totalValorBruto)
      : somar(data.map((d) => d.valorBruto))
  );
  const totalValorIr = getTotalValue(
    totaisDoServidor
      ? Number(getAllAgrupado.totalValorIr)
      : somar(data.map((d) => d.valorIr))
  );
  const totalValorLiquido = getTotalValue(
    totaisDoServidor
      ? Number(getAllAgrupado.totalValorLiquido)
      : somar(data.map((d) => d.valorLiquido))
  );

  const selecionadosValorBruto = getTotalValue(
    somar(listaSelecionados.map((d) => d.valorBruto))
  );
  const selecionadosValorLiquido = getTotalValue(
    somar(listaSelecionados.map((d) => d.valorLiquido))
  );

  return (
    <>
      <Col>
        <Col>
          <Col className="conferencia-cr-filtros">
            <div className="conferencia-cr-filtros-titulo">
              <Label>Pesquisar</Label>
            </div>
            <Form>
              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Nome Arquivo:</Label>
                    <Input
                      type="text"
                      placeholder="Digite aqui"
                      value={search.nomeArquivo}
                      onChange={(e) => onChange(e.target.value, "nomeArquivo")}
                      autoComplete="true"
                    />
                  </FormGroup>
                </Col>
                <Col className="d-flex" md={4}>
                  <FormGroup className="flex-grow-1">
                    <Label>Loja Matriz:</Label>
                    <Input
                      type="text"
                      placeholder="Busque um favorecido..."
                      value={search.loja}
                      disabled
                      className="flex-grow-1"
                    />
                  </FormGroup>
                  <GrFormClose
                    className="conferencia-cr-icone"
                    onClick={() => {
                      onChange("", "loja");
                      onChange("0", "lojaId");
                    }}
                  />
                  <AiOutlineSearch
                    className="conferencia-cr-icone conferencia-cr-icone-busca"
                    onClick={() => toggleLoja()}
                  />
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label>Centro Custo:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.centroCustoId }}
                      select={{ value: "id", label: "descricao" }}
                      options={centrosCusto}
                      onChange={(e) => {
                        onChange(e.value, "centroCustoId");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>

                <Col md={2}>
                  <FormGroup>
                    <Label>Banco:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.instituicaoId }}
                      select={{ value: "id", label: "nome" }}
                      options={instituicoes}
                      onChange={(e) => {
                        onChange(e.value, "instituicaoId");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Cód. Loja Banco:</Label>
                    <Input
                      type="text"
                      placeholder="Digite aqui"
                      value={search.lojaBanco}
                      onChange={(e) => onChange(e.target.value, "lojaBanco")}
                      autoComplete="true"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Tipo Comissão:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.tipoComissaoId }}
                      select={{ value: "id", label: "descricao" }}
                      options={tiposComissao}
                      onChange={(e) => {
                        onChange(e.value, "tipoComissaoId");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Status Título:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.statusComissaoRecebidaId }}
                      select={{ value: "id", label: "descricao" }}
                      options={statusComissaoRecebida}
                      onChange={(e) => {
                        onChange(e.value, "statusComissaoRecebidaId");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Tipo Título:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.tipoTitulo }}
                      select={{ value: "id", label: "descricao" }}
                      options={tiposTitulo}
                      onChange={(e) => {
                        onChange(e.value, "tipoTitulo");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Conta Bancária:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.contaBancaria }}
                      select={{ value: "id", label: "conta" }}
                      options={contasCorrente}
                      onChange={(e) => {
                        onChange(e.value, "contaBancaria");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <Label>Documento:</Label>
                    <Input
                      type="text"
                      placeholder="Digite aqui"
                      value={search.documento}
                      onChange={(e) => onChange(e.target.value, "documento")}
                      autoComplete="true"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label>Título:</Label>
                    <Input
                      type="text"
                      placeholder="Digite o nº do título"
                      value={search.titulo}
                      onChange={(e) => onChange(e.target.value, "titulo")}
                      autoComplete="true"
                    />
                  </FormGroup>
                </Col>

                <Col md={2}>
                  <FormGroup>
                    <Label>Status Integração:</Label>
                    <Select
                      first="Selecione"
                      value={{ value: search.integrado }}
                      select={{ value: "id", label: "descricao" }}
                      options={integrado}
                      onChange={(e) => {
                        onChange(e.value, "integrado");
                      }}
                      isSearchable={true}
                      autoComplete="off"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      Emissão Inicial:
                    </Label>
                    <Input
                      type="date"
                      value={search.DataEmissaoInicial}
                      onChange={(e) =>
                        onChange(e.target.value, "DataEmissaoInicial")
                      }
                      max="9999-12-31"
                      className="conferencia-cr-input-data"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label className="font-weight-bold">Emissão Final:</Label>
                    <Input
                      type="date"
                      value={search.DataEmissaoFinal}
                      onChange={(e) =>
                        onChange(e.target.value, "DataEmissaoFinal")
                      }
                      max="9999-12-31"
                      className="conferencia-cr-input-data"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="align-items-center">
                <Col md={2}>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      Vencimento Inicial:
                    </Label>
                    <Input
                      type="date"
                      value={search.DataVencimentoInicial}
                      onChange={(e) =>
                        onChange(e.target.value, "DataVencimentoInicial")
                      }
                      max="9999-12-31"
                      className="conferencia-cr-input-data"
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      Vencimento Final:
                    </Label>
                    <Input
                      type="date"
                      value={search.DataVencimentoFinal}
                      onChange={(e) =>
                        onChange(e.target.value, "DataVencimentoFinal")
                      }
                      max="9999-12-31"
                      className="conferencia-cr-input-data"
                    />
                  </FormGroup>
                </Col>
                <Col md={2} className="conferencia-cr-col-botao">
                  <Button
                    className="conferencia-cr-botao conferencia-cr-botao-limpar"
                    onClick={actions.cleanSearch}
                  >
                    Limpar
                  </Button>
                </Col>
                <Col md={2} className="conferencia-cr-col-botao">
                  <Button
                    className="purpleButton conferencia-cr-botao"
                    onClick={() => getAll()}
                  >
                    Buscar
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Col>
        <div className="conferencia-cr-acoes">
          <div>
            <Button
              className="conferencia-cr-botao-acao conferencia-cr-botao-baixa"
              disabled={quantidadeSelecionados === 0}
              onClick={() => setIsModalBaixaOpen(true)}
            >
              Realizar baixa dos selecionados
              {quantidadeSelecionados > 0 ? ` (${quantidadeSelecionados})` : ""}
            </Button>
          </div>
          <div>
            <Button
              className="conferencia-cr-botao-acao conferencia-cr-botao-exportar"
              onClick={() => handleBaixarComissoes()}
            >
              <PiMicrosoftExcelLogoLight className="conferencia-cr-icone-excel" />
              Exportar página
            </Button>
          </div>
          <div>
            <Button
              className="conferencia-cr-botao-acao conferencia-cr-botao-exportar"
              disabled={quantidadeSelecionados === 0}
              onClick={() => handleBaixarCP()}
            >
              <PiMicrosoftExcelLogoLight className="conferencia-cr-icone-excel" />
              Exportar CP dos selecionados
            </Button>
          </div>
        </div>
        <div className="conferencia-cr-tabela">
          <table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  <th className="conferencia-cr-th-checkbox">
                    <div className="d-flex justify-content-center">
                      <input
                        className="conferencia-cr-checkbox-header"
                        type="checkbox"
                        checked={todosDaPaginaSelecionados}
                        onChange={() => handleSelectAllComissoes()}
                      />
                    </div>
                  </th>
                  {headerGroup.headers.map((column) => (
                    <th key={column.id} className="conferencia-cr-th-coluna">
                      <span className="float-left">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <BsArrowDown
                              {...column.getHeaderProps(
                                column.getSortByToggleProps({
                                  title: undefined,
                                })
                              )}
                            />
                          ) : (
                            <BsArrowUp
                              id="OrdenarAsc"
                              {...column.getHeaderProps(
                                column.getSortByToggleProps({
                                  title: undefined,
                                })
                              )}
                            />
                          )
                        ) : (
                          <BsArrowDownUp
                            {...column.getHeaderProps(
                              column.getSortByToggleProps({
                                title: undefined,
                              })
                            )}
                          />
                        )}
                      </span>
                      {column.render("Header")}
                    </th>
                  ))}
                  <th className="text-center">Ações</th>
                </tr>
              ))}
            </thead>

            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    className="text-center"
                    {...row.getRowProps()}
                    index={row.original.id}
                  >
                    <td>
                      <input
                        type="checkbox"
                        className="conferencia-cr-checkbox-linha"
                        checked={!!selecionados[row.original.id]}
                        onChange={() => handleSelectComissao(row.original)}
                      />
                    </td>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                    <td className="conferencia-cr-td-acoes">
                      <>
                        <AiOutlineEye
                          className="conferencia-cr-icone-visualizar"
                          onClick={() => seeRegister(row.original.id)}
                        />
                      </>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="pt-4">
          <Row className="justify-content-center">
            <Col xs={10} md={8} lg={6}>
              <div className="conferencia-cr-totais">
                <div>
                  <strong>Valor Total Bruto{rotuloTotais}:</strong> R${" "}
                  {totalValorBruto}
                </div>
                <div>
                  <strong>Valor Total IR{rotuloTotais}:</strong> R$ {totalValorIr}
                </div>
                <div>
                  <strong>Valor Total Líquido{rotuloTotais}:</strong> R${" "}
                  {totalValorLiquido}
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <Row className="pt-4">
          <Col>
            <span className="conferencia-cr-paginacao-info">
              Mostrando{" "}
              {getAllAgrupado.quantidade ? getAllAgrupado.quantidade : "0"} de{" "}
              {getAllAgrupado.quantidadeTotal
                ? getAllAgrupado.quantidadeTotal
                : "0"}
            </span>
          </Col>
          <Col md={8}>
            <Row className="float-right">
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={getAllAgrupado.totalPaginas}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={initialPage ? 0 : selectedPage}
              />
              <Input
                type="select"
                className="pageSize"
                value={pageSize}
                onChange={(e) => {
                  handleInitialPage(e.target.value);
                  setPageSize(Number(e.target.value));
                }}
              >
                {[10, 25, 100].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </Input>
            </Row>
          </Col>
        </Row>
      </Col>

      <div className="d-none">
        <a
          id="download"
          href={`data:application/xlsx;base64,${arquivo}`}
          download={"Planilha.xlsx"}
        >
          .
        </a>
      </div>
      <div className="d-none">
        <a
          id="downloadCP"
          href={`data:application/xlsx;base64,${arquivoCp}`}
          download={"PlanilhaCP.xlsx"}
        >
          .
        </a>
      </div>
      <Modal
        isOpen={isModalBaixaOpen}
        toggle={() => setIsModalBaixaOpen(false)}
        className="text-center"
      >
        <ModalHeader toggle={() => setIsModalBaixaOpen(false)}>
          Confirmar baixa
        </ModalHeader>
        <ModalBody>
          <p>
            Você está prestes a realizar a baixa de{" "}
            <strong>{quantidadeSelecionados}</strong> título(s).
          </p>
          <p className="mb-1">
            Valor Bruto: <strong>R$ {selecionadosValorBruto}</strong>
          </p>
          <p>
            Valor Líquido: <strong>R$ {selecionadosValorLiquido}</strong>
          </p>
          <p className="mb-0 conferencia-cr-aviso">
            Essa ação não pode ser desfeita.
          </p>
        </ModalBody>
        <ModalFooter className="justify-content-center">
          <Button color="danger" onClick={() => setIsModalBaixaOpen(false)}>
            Cancelar
          </Button>
          <Button
            className="conferencia-cr-botao-confirmar"
            onClick={() => confirmarBaixa()}
          >
            Confirmar baixa
          </Button>
        </ModalFooter>
      </Modal>
      {<ModalLoja isOpen={isModalLojaOpen} toggle={toggleLoja} />}
      {
        <ModalDetalhamento
          isOpen={isModalDetalhamentoOpen}
          toggle={toggleDetalhamento}
          id={comissaoId}
        />
      }
    </>
  );
};

export default SearchConferenciaCr;
